/** TODO: remove this file after BE fixes category descriptions */

import { I_AP_CATEGORY_ID_ENUM, type IAPCategoryReduced } from '@/_types'

const CHILD_CATEGORY_DESCRIPTION_BE_BUG =
	'Vašu starosť o zdravie detí meníme na radosť. Postaráme sa o ne s celostným a láskavým prístupom od narodenia po dospelosť a od začiatku do konca roka. Svojimi odbornými radami ich spoločne s vami vedieme k zdravému životnému štýlu. Vyberte si z našich Medante ročných balíkov pre deti.'

const CHILD_CATEGORY_DESCRIPTION_FIXED =
	'Vašu starosť o zdravie detí meníme na radosť. Postaráme sa o ne s odborným a láskavým prístupom od narodenia až po dospelosť. Odbornými radami ich spoločne s vami vedieme k zdravému životnému štýlu. Vyberte si z našich Medante ročných balíkov pre deti.'

const MALE_CATEGORY_DESCRIPTION_BE_BUG =
	'Naše programy zdravotnej starostlivosti pre mužov sú navrhnuté tak, aby sme vám poskytli celostný prístup k zdraviu podľa vlastných potrieb počas celého roka. Aj keď je zdravie len jedno, balíkov služieb máme viac, pre splnenie všetkých očakávaní, ktoré môžete mať.'

const MALE_CATEGORY_DESCRIPTION_FIXED =
	'Naše programy zdravotnej starostlivosti pre mužov sú navrhnuté tak, aby sme vám poskytli ľudský prístup k zdraviu podľa vlastných potrieb počas celého roka. Aj keď je zdravie len jedno, balíkov služieb máme viac, pre splnenie všetkých očakávaní, ktoré môžete mať.'

const applyDescriptionOverride = (
	category: IAPCategoryReduced,
	from: string,
	to: string
): IAPCategoryReduced => {
	if (category.description !== from) {
		return category
	}

	return { ...category, description: to }
}

export function applyAPCategoryDescriptionOverrides(
	categories: IAPCategoryReduced[]
): IAPCategoryReduced[] {
	return categories.map(category => {
		const isChildCategory =
			category.slug === 'deti' || category.id === I_AP_CATEGORY_ID_ENUM.CHILD
		const isMaleCategory =
			category.slug === 'muzi' || category.id === I_AP_CATEGORY_ID_ENUM.MALE

		if (isChildCategory) {
			return applyDescriptionOverride(
				category,
				CHILD_CATEGORY_DESCRIPTION_BE_BUG,
				CHILD_CATEGORY_DESCRIPTION_FIXED
			)
		}

		if (isMaleCategory) {
			return applyDescriptionOverride(
				category,
				MALE_CATEGORY_DESCRIPTION_BE_BUG,
				MALE_CATEGORY_DESCRIPTION_FIXED
			)
		}

		return category
	})
}
